import { ILocationGratuity, CustomTipType } from '@ready/dashboardv2api.contracts';

export interface ITipConfigurationState {
  loading: boolean;
  error: boolean;
  data: ILocationGratuity;
  initialized: boolean;
}

export const initialTipConfiguration: ITipConfigurationState = {
  loading: false,
  error: false,
  data: {
    allowTips: true,
    preNonReadyPaymentsTip: true,
    preDiscountTip: true,
    preItemDiscountTip: true,
    preTaxTip: false,
    bottomText: '',
    showBottomText: false,
    defaultTips: [15, 18, 20],
    defaultTipsForServiceCharges: [0, 2, 5],
    defaultCustomTipType: CustomTipType.Percentage,
    forcedTipEnabled: false,
    forcedTipPercentage: 0,
  },
  initialized: false,
};